// import React, { useState } from "react";
// import Generate_Externally_Service_modal from "../generate_Externally_Service_modal/Generate_Externally_Service_modal";
// import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

// function Externally_Service_table({ data, currentPage, setCurrentPage }) {
//   const [showModal, setModal] = useState(false);
//   const tableData = data?.data || [];
//   const totalPages = data?.total_pages || 1;

//   /* ================= TABLE DATA ================= */

//   // const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // const totalPages = Math.ceil(data.length / itemsPerPage);

//   const paginatedData = data.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage,
//   );

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <>
//       <section className="Imperiality_table">
//         <div className="common_table_container theme_bg">
//           <div className="table-responsive">
//             <table className="common_table table table-striped customer_table">
//               <thead>
//                 <tr>
//                   <th>Sr. No</th>
//                   <th>Document Name</th>
//                   <th>Attached File</th>
//                   <th>Remarks</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {tableData.length > 0 ? (
//                   tableData.map((row, index) => (
//                     <tr key={row.id}>
//                       {/* Sr No */}
//                       <td>{(currentPage - 1) * data.per_page + index + 1}</td>

//                       {/* Document Name */}
//                       <td>{row.name}</td>

//                       {/* Attached File */}
//                       <td>{row.Service_Used?.name || "--"}</td>

//                       {/* Remarks */}
//                       <td>{row.remark || "--"}</td>

//                       {/* Action */}
//                       <td>
//                         <div className="action_icons">
//                           <p
//                             className="blue_link_text"
//                             onClick={() => setModal(true)}
//                           >
//                             Generate
//                           </p>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="5" className="text-center">
//                       No data found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//         <div className="comon_page_footer">
//           <div className="show_entry_div">
//             <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
//           </div>

//           <div className="pagination_div">
//             <Pagination_Holder
//               onPageChange={currentPage}
//               totalPages={totalPages}
//               handlePageChange={setCurrentPage}
//             />
//           </div>
//         </div>
//       </section>

//       <Generate_Externally_Service_modal
//         show={showModal}
//         onHide={() => setModal(false)}
//         modalHeadingText={"Externally Provided Product & Service"}
//       />
//     </>
//   );
// }

// export default Externally_Service_table;

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Generate_Externally_Service_modal from "../generate_Externally_Service_modal/Generate_Externally_Service_modal";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../utils/common";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useDispatch, useSelector } from "react-redux";
import Externally_Service_Edit_Offcanvas from "../Externally_Service_Edit_Offcanvas/Externally_Service_Edit_Offcanvas";
import {
  GetAll,
  Delete,
} from "../../../../../../../features/admin/quality_management/resource_requirement/externaldetails/Slice";

function Externally_Service_table({ data, currentPage, setCurrentPage ,fetchCustomers}) {
  const [showModal, setModal] = useState(false);

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  const tableData = data?.data || [];
  const totalPages = data?.total_pages || 1;
  const perPage = data?.per_page || 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.externally_provided.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.externally_provided.Delete,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.externally_provided.View,
  );

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Vendor Name</th>
                  <th>Address</th>
                  <th>Contact Person</th>
                  <th>Email</th>
                  <th>Mobile No</th>
                  <th>Service Used</th>
                  <th>Performance</th>
                  <th>Remarks</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((row, index) => (
                    <tr key={row.id}>
                      {/* Sr No */}
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>{formatDate(row?.createdAt)}</td>

                      {/* Document Name */}
                      <td>{row.name}</td>
                      <td>{row.address}</td>
                      <td>{row.contact_person_name}</td>
                      <td>{row.email}</td>
                      <td>{row.contact_no}</td>

                      {/* Attached File */}
                      <td>{row.Service_Used?.name || "--"}</td>
                      <td>{row.Performance?.name}</td>
                      {/* Remarks */}
                      <td>{row.remark || "--"}</td>

                      {/* Action */}
                      {/* <td>
                        <div className="action_icons">
                          <p
                            className="blue_link_text"
                            onClick={() => setModal(true)}
                          >
                            Generate
                          </p>
                        </div>
                      </td> */}

                      {/* Action */}
                      <td>
                        <div className="action_icons">
                          {haveEditPermission && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => {
                                setEdit(true);
                                setEditId(row.id);
                              }}
                            />
                          )}
                          {haveDeletePermission && (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              onClick={() => {
                                setSelectedDeleteId(row.id); // store ID
                                setDelete(true); // open offcanvas
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing page {currentPage} of {totalPages}
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* Edit */}
      {haveEditPermission && (
        <Externally_Service_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}


      { haveDeletePermission && <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete Externally Provided Product & Service"
        massageText={"Externally Provided Product & Service"}
      />}

      <Generate_Externally_Service_modal
        show={showModal}
        onHide={() => setModal(false)}
        modalHeadingText={"Externally Provided Product & Service"}
      />
    </>
  );
}

export default Externally_Service_table;
